import React from "react";

const NoEntry = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
	<svg
		width={size}
		style={style}
		height={size}
		viewBox={viewBox}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={`${className || ""}`}
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<path
			className="u_fill"
			d="M17.75 2h1.188c.1.023.2.053.3.067.729.108 1.467.172 2.185.325 6.172 1.316 11.14 6.399 12.32 12.584.09.466.172.933.257 1.399v3.188c-.03.161-.066.322-.089.485-.407 2.873-1.478 5.468-3.29 7.738-2.641 3.308-6.04 5.346-10.236 6.019-.48.077-.965.13-1.448.195H17.75c-.142-.023-.284-.047-.427-.067-.995-.142-2.011-.202-2.983-.44-3.74-.914-6.776-2.947-9.058-6.034-2.946-3.983-3.866-8.431-2.704-13.256.89-3.7 2.945-6.672 5.968-8.961a15.461 15.461 0 017.844-3.104c.453-.047.907-.092 1.36-.138zm7.383 6.064c-4.913-3.561-11.857-3.27-16.447 2.073-4.124 4.802-3.503 11.083-.592 14.881L25.132 8.064zm2.847 2.866L11.027 27.954c3.92 3.044 10.562 3.578 15.547-1.235 4.793-4.626 4.707-11.333 1.406-15.789z"
			fill={fill}
		/>
	</svg>
);

export default NoEntry;
